import { createUUID, calcPrice, calcVatAmount } from './methods';

export const products =  [
	{ id: 1, productIdentifier: createUUID(), price: 59.12, name: 'iPhone 14 Pro Leather Case', description: 'with MagSafe', pID: 0, img: 'i14_leathercase.png', inBasket: false, count: 0},
	{ id: 2, productIdentifier: createUUID(), price: 49, name: 'iPhone 14 Clear Case', description: 'with MagSage', pID: 0, img: 'i14_clear_case.png', inBasket: false, count: 0},
	{ id: 3, productIdentifier: createUUID(), price: 249, name: 'Airpods Pro', description: 'Second Generation', pID: 0, img: 'airpod_pro.png', inBasket: false, count: 0},
	{ id: 4, productIdentifier: createUUID(), price: 19, name: 'Power Adapter', description: '20W USB-C Power Adapter', pID: 0, img: '20W_USB.png', inBasket: false, count: 0},
	{ id: 5, productIdentifier: createUUID(), price: 29, name: 'Airtag', description: 'Free Engraving', pID: 0, img: 'airtag.png', inBasket: false, count: 0},
	{ id: 6, productIdentifier: createUUID(), price: 19, name: 'USB-C Cable', description: '1 meter USB to Lightnig Cable', pID: 0, img: 'cable.png', inBasket: false, count: 0},
];

const initialState = {
	storeName: 'Apple Accessoires',	
	totalItems: 0,	totalAmount: 0,	
	vat: 0.19,
	currency: 'dollar',
	currencyIcon: '$',
	pagination: {
		itemsPerPage: 5,
		startPage: 1
	}, 
	products,
	orders: []
}

initialState.products = initialState.products.map( item => {
	let _item = { ...item};
	_item.price = calcPrice(item.price);
	_item.vat = calcVatAmount(item.price, initialState.vat);
	return _item;
});

export default initialState;